import { useLayoutEffect, useRef, useState } from "react";

export const useLocateFloatingComponent = (modalHeight: number) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });

  useLayoutEffect(() => {
    const updatePosition = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const spaceBelow = viewportHeight - rect.bottom;
        const spaceAbove = rect.top;

        let topPosition;
        if (spaceBelow >= modalHeight) {
          topPosition = rect.bottom + 8;
        } else if (spaceAbove >= modalHeight) {
          topPosition = rect.top - modalHeight - 8;
        } else {
          topPosition = Math.max(8, rect.bottom + 8 - viewportHeight + modalHeight);
        }

        setPosition({
          top: topPosition,
          left: rect.left,
          width: rect.width,
        });
      }
    };

    updatePosition();

    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);

    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
  }, [modalHeight]);

  return { containerRef, position };
};
